<template>
  <div>
    <ModalViewCredential
      @closeModal="closeModalView"
      v-if="credentials != null"
      :credentialsProps="credentials"
      :programName="programName"
    />
    <b-modal
      size="md"
      centered
      no-close-on-backdrop
      ok-title="Enviar"
      id="modal-confirm-password"
      modal
      :title="$ml.get('informPassword')"
    >
      <div class="login">
        <p class="label-confirm">
          {{ $ml.get("confirmPasswordToViewCredential") }} <b>{{ $ml.get("confirmPasswordToViewCredentialContinued") }}</b>
        </p>
        <div class="form-group" style="position: relative">
          <input
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            v-model.trim="password"
            name="password"
            placeholder="********"
            maxlength="50"
          />
          <VueCustomTooltip
            :label="$ml.get(showPassword ? 'unshowPassword' : 'showPassword')"
            class="login-ico visible-password"
            style="position: absolute"
          >
            <svg class="ico-20" @click="showPassword = !showPassword">
              <image
                v-show="showPassword"
                xlink:href="../../assets/icons/eye-slash.svg"
                width="20"
                height="20"
              />
              <image
                v-show="!showPassword"
                xlink:href="../../assets/icons/eye.svg"
                width="20"
                height="20"
              />
            </svg>
          </VueCustomTooltip>
          <transition name="fade">
            <label v-if="errorPassword" class="lblError">
              {{ $ml.get("invalidPassword") }}
            </label>
          </transition>
        </div>
      </div>
      <template #modal-footer="{ ok }">
        <b-button
          style="background: #730ba9; min-width: 90px"
          :disabled="!password"
          size="sm"
          @click="confirmPassword(ok)"
        >
          <span>{{ $ml.get("confirmBtn") }}</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import CredentialService from "../../services/credential.service.js";
import ModalViewCredential from "./ModalViewCredential.vue";
import Swal from "sweetalert2";
export default {
  name: "ConfirmPassword",
  props: [ "programName"],
  components: {
    ModalViewCredential,
  },
  data() {
    return {
      password: "",
      credentials: null,
      showPassword: false,
      errorPassword: false,
      programId:"",
    };
  },
  watch: {
    password() {
      this.errorPassword = false;
    },
  },
  mounted(){
    this.programId =this.$route.fullPath.split("?")[1]

  },
  methods: {
    async confirmPassword(ok) {
      try {
        const { data, status } = await CredentialService.postConfirmPassword(
          this.programId,
          {
            password: this.password,
          },
        );
        this.credentials = data;

        if (status === 201) {
          ok();
          this.password = "";
          this.showPassword = false;

          setTimeout(() => {
            this.$bvModal.show("modal-view-credential");
          }, 500);
        }
      } catch (error) {
        const { status } = error.response;
        if (status === 401) {
          this.errorPassword = true;
        }
        if (status === 500) {
          Swal.fire({
          icon: "error",
          title: "Oops...",
          text: this.$ml.get("genericError"),
          });
        }
      }
    },
    closeModalView() {
      this.$bvModal.hide("modal-view-credential");
    },
  },
};
</script>
<style scoped>
.visible-password {
  top: 0px;
  right: 5px;
  transform: translate(-50%, 50%);
}
.label-confirm {
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.3;
}
.label-confirm span {
  text-decoration: underline;
}
</style>
